<template>
  <v-app id="to_auth0">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" md="3" sm="6">
            <v-card class="elevation-12">
              <v-toolbar color="#9efcbd" light flat dense>
                <v-toolbar-title>Welcome to MAP.IZONE.UA</v-toolbar-title>              
              </v-toolbar>
              <v-card-actions>
                <v-btn @click="goToLogin" color="black" block x-large outlined dark>GO TO LOGIN</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    name: 'ToAuth0',
    data: () => ({
    }),
    props: ['writeTokens',],
    mounted() {
      window.addEventListener("message", (message) =>  {
        if ('name' in message.data && message.data.name === "login") {
          if (typeof this.writeTokens === "function") {
            this.writeTokens(message.data.access, message.data.refresh);
          }
        }
      });
    },
    methods: {
      goToLogin() {
        window.open('https://map.izone.ua/api/login/auth0');
      }
    },
  }
</script>
